__turbopack_context__.v({
  "bottom-left-element": "ObjectCardImage-module-scss-module__In3l_q__bottom-left-element",
  "explicit-label": "ObjectCardImage-module-scss-module__In3l_q__explicit-label",
  "image": "ObjectCardImage-module-scss-module__In3l_q__image",
  "placeholder": "ObjectCardImage-module-scss-module__In3l_q__placeholder",
  "top-left-element": "ObjectCardImage-module-scss-module__In3l_q__top-left-element",
});
